import pulse from '@finn-no/pulse-sdk';

window.addEventListener('DOMContentLoaded', function () {
    const state = {
        vertical: {
            name: 'business_center',
        },
    };

    const market = document.querySelector('meta[name="market"]');
    if (market) {
        state.vertical.subVertical = market.content;
    }

    pulse.setState(state);

    pulse.trackPageView({
        object: {
            type: 'Page',
            pageType: 'landingpage',
        },
    });
});
